import {audit, filter} from 'rxjs/operators';
import {iif, of} from 'rxjs';

export const auditByBooleanState = (filterStateProvider, passthroughObservable) => obs$ => obs$.pipe(
	audit(() =>
		iif(
			filterStateProvider,
			of(true),
			passthroughObservable.pipe(
				filter(filterStateProvider),
			),
		),
	),
);
